import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGroup, faHeart, faEarthEurope } from '@fortawesome/free-solid-svg-icons';

export function MentorHome() {
    useEffect(() => {
    }, []);

    return <>
        <header className="bg-primary-gradient">
            <div className="container pt-4 pt-xl-5">
                <div className="row pt-5">
                    <div className="col-md-8 col-xl-6 text-center text-md-start mx-auto">
                        <div className="text-center">
                            <p className="fw-bold text-success mb-2">어학, 유학, 취업, 워홀, 이민을 위한 성장 네트워킹 플랫폼</p>
                            <h1 className="fw-bold" class="text-4xl md:text-5xl font-bold text-gray-800 leading-tight" style={{ fontFamily: 'Nanum Gothic' }}>독일 한인 <br />멘토-멘티 매칭 서비스 🇩🇪</h1>
                        </div>
                    </div>
                    <div className="col-12 col-lg-10 mx-auto">
                        <div className="position-relative" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                            <div style={{ position: 'relative', flex: '0 0 45%', transform: 'translate3d(-15%, 35%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.8" src="/assets/img/mentor/1.jpg" alt="product_3" style={{ width: '650px', height: 'auto' }} /></div>
                            <div style={{ position: 'relative', flex: '0 0 45%', transform: 'translate3d(-5%, 20%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.4" src="/assets/img/mentor/2.jpg" alt="product_2" style={{ width: '350px', height: 'auto' }} /></div>
                            <div style={{ position: 'relative', flex: '0 0 60%', transform: 'translate3d(0, 0%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.25" src="/assets/img/mentor/3.jpg" alt="product_1" style={{ width: '350px', height: 'auto' }} /></div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <section>
            <div className="container py-4 py-xl-5">
                <section className="py-4 py-xl-5">
                    <div className="container">
                        <div className="text-dark bg-light border rounded border-0 border-light d-flex flex-column flex-lg-row justify-content-center align-items-center text-center p-4 p-md-5">
                            <div className="pb-2 pb-lg-1">
                                <h2 className="fw-bold mb-2">독일에서 성공적인 성장과 네트워킹</h2>
                                <p className="mb-0" style={{ fontFamily: 'Nanum Gothic' }}>
                                    현지 경험이 풍부한 멘토와 직접 연결되어 어학, 취업, 학업, 생활에 필요한 정보 및 지혜를 얻을 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* 활성화 */}
                {/* <div className="row gy-4 row-cols-2 row-cols-md-4">
                    <div className="col">
                        <div className="text-center d-flex flex-column justify-content-center align-items-center py-3">
                            <div className="px-3">
                                <h2 className="fw-bold mb-0">123+</h2>
                                <p className="mb-0" style={{fontWeight: 'bold', fontFamily: 'Nanum Gothic'}}>XX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="text-center d-flex flex-column justify-content-center align-items-center py-3">
                            <div className="px-3">
                                <h2 className="fw-bold mb-0">111+</h2>
                                <p className="mb-0" style={{fontWeight: 'bold', fontFamily: 'Nanum Gothic'}}>XX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="text-center d-flex flex-column justify-content-center align-items-center py-3">
                            <div className="px-3">
                                <h2 className="fw-bold mb-0">111+</h2>
                                <p className="mb-0" style={{fontWeight: 'bold', fontFamily: 'Nanum Gothic'}}>XX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="text-center d-flex flex-column justify-content-center align-items-center py-3">
                            <div className="px-3">
                                <h2 className="fw-bold mb-0">111</h2>
                                <p className="mb-0" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>XX</p>
                            </div>
                        </div>
                    </div>
                </div>*/}
            </div>
        </section>
        {/* <section className="py-5">
            <div className="container py-4 py-xl-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <h2 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>혼자가 아닌 여정, 멘토가 함께합니다.</h2>
                    </div>
                </div>
                <div className="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-3">
                    <div className="col">
                        <div className="card">
                            <div className="card-body p-4">
                                <h4 className="card-title" style={{fontFamily: 'Nanum Gothic'}}>같은 길을 걸어온 한인 선배의 진솔한 경험을 나눕니다.</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card">
                            <div className="card-body p-4">
                                <h4 className="card-title" style={{fontFamily: 'Nanum Gothic'}}>당신의 상황을 이해하는 멘토와 자연스럽게 이어집니다.</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card">
                            <div className="card-body p-4">
                                <h4 className="card-title" style={{fontFamily: 'Nanum Gothic'}}>낯선 독일 생활, 함께라면 훨씬 든든해집니다.</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
        <section className="py-5 bg-light">
            <div className="container py-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <h2 className="fw-bold mb-3" style={{ fontFamily: 'Nanum Gothic' }}>
                            혼자가 아닌 여정, <span className="text-success">멘토가 함께합니다.</span>
                        </h2>
                        <p className="text-muted">
                            같은 길을 걸어온 선배와 함께하는 따뜻한 독일 생활 멘토링
                        </p>
                    </div>
                </div>

                <div className="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-3">
                    <div className="col">
                        <div
                            className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                            style={{ borderRadius: '1rem' }}
                        >
                            <div
                                className="icon-circle bg-danger bg-opacity-10 text-danger mx-auto mb-3 d-flex align-items-center justify-content-center"
                                style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                            >
                                <FontAwesomeIcon icon={faHeart} style={{ fontSize: '1.5rem' }}/>
                            </div>
                            <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                같은 길을 걸어온 한인 선배의 진솔한 경험을 나눕니다.
                            </h5>
                        </div>
                    </div>

                    <div className="col">
                        <div
                            className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                            style={{ borderRadius: '1rem' }}
                        >
                            <div
                                className="icon-circle bg-primary bg-opacity-10 text-primary mx-auto mb-3 d-flex align-items-center justify-content-center"
                                style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                            >
                                <FontAwesomeIcon icon={faUserGroup} style={{ fontSize: '1.5rem' }}/>
                            </div>
                            <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                당신의 상황을 이해하는 멘토와 자연스럽게 이어집니다.
                            </h5>
                        </div>
                    </div>
                    <div className="col">
                        <div
                            className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                            style={{ borderRadius: '1rem' }}
                        >
                            <div
                                className="icon-circle bg-warning bg-opacity-10 text-warning mx-auto mb-3 d-flex align-items-center justify-content-center"
                                style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                            >
                                <FontAwesomeIcon icon={faEarthEurope} style={{ fontSize: '2rem' }}/>
                            </div>
                            <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                낯선 독일 생활, 함께라면 훨씬 든든해집니다.
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div className="container bg-primary-gradient py-5">
                <div className="row">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <p className="fw-bold text-success mb-2">멘토-멘티 연결</p>
                        <h3 className="fw-bold">독일 한인만을 위한 맞춤형 매칭 서비스</h3>
                    </div>
                </div>
                <div className="py-5 p-lg-5">
                    <div className="row row-cols-1 row-cols-md-2 mx-auto" style={{ maxWidth: '900px' }}>
                        <div className="col mb-5">
                            <div className="card shadow-sm">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-bell text-success">
                                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6"></path>
                                    </svg></div>
                                    <h5 className="fw-bold card-title">멘토 네트워크</h5>
                                    <p className="text-muted card-text mb-4">검증된 멘토와 연결되어 개인 맞춤형 상담과 지원을 받을 수 있습니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-5">
                            <div className="card shadow-sm">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-bezier text-success">
                                        <path fillRule="evenodd" d="M0 10.5A1.5 1.5 0 0 1 1.5 9h1A1.5 1.5 0 0 1 4 10.5v1A1.5 1.5 0 0 1 2.5 13h-1A1.5 1.5 0 0 1 0 11.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm10.5.5A1.5 1.5 0 0 1 13.5 9h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM6 4.5A1.5 1.5 0 0 1 7.5 3h1A1.5 1.5 0 0 1 10 4.5v1A1.5 1.5 0 0 1 8.5 7h-1A1.5 1.5 0 0 1 6 5.5zM7.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"></path>
                                        <path d="M6 4.5H1.866a1 1 0 1 0 0 1h2.668A6.517 6.517 0 0 0 1.814 9H2.5c.123 0 .244.015.358.043a5.517 5.517 0 0 1 3.185-3.185A1.503 1.503 0 0 1 6 5.5zm3.957 1.358A1.5 1.5 0 0 0 10 5.5v-1h4.134a1 1 0 1 1 0 1h-2.668a6.517 6.517 0 0 1 2.72 3.5H13.5c-.123 0-.243.015-.358.043a5.517 5.517 0 0 0-3.185-3.185z"></path>
                                    </svg></div>
                                    <h5 className="fw-bold card-title">사회적 신뢰&nbsp;</h5>
                                    <p className="text-muted card-text mb-4">독일 내 한인 커뮤니티와 협력하여 신뢰할 수 있는 정보를 제공합니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4">
                            <div className="card shadow-sm">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-pin-angle text-success">
                                        <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146zm.122 2.112v-.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a4.507 4.507 0 0 0-.288-.076 4.922 4.922 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a4.924 4.924 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034.114 0 .23-.011.343-.04L9.927 2.028c-.029.113-.04.23-.04.343a1.779 1.779 0 0 0 .062.46z"></path>
                                    </svg></div>
                                    <h5 className="fw-bold card-title">직접 매칭 관리</h5>
                                    <p className="text-muted card-text mb-4">매칭 단계에서부터 철저히 관리하여, 멘토-멘티 간 만족도를 높입니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4">
                            <div className="card shadow-sm">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-chat-quote text-success">
                                        <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894m-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"></path>
                                        <path d="M7.066 6.76A1.665 1.665 0 0 0 4 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"></path>
                                    </svg></div>
                                    <h5 className="fw-bold card-title">개인정보 보호</h5>
                                    <p className="text-muted card-text mb-4">모든 상담과 매칭 과정에서 개인정보와 대화 내용은 철저히 보호됩니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <section>
            <div className="container py-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <h2 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>XX</h2>
                    </div>
                </div>
                <div className="mx-auto" style={{maxWidth: '900px'}}>
                    <div className="row row-cols-1 row-cols-md-2 d-flex justify-content-center">
                        <div className="col mb-4">
                            <div className="card bg-primary-subtle">
                                <div className="card-body text-center px-4 py-5 px-md-5">
                                    <h5 className="fw-bold card-title mb-3">XX</h5>
                                    <p className="fw-bold text-primary card-text mb-2">XX</p><button className="btn btn-primary btn-sm" type="button">XX</button>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4">
                            <div className="card bg-secondary-subtle">
                                <div className="card-body text-center px-4 py-5 px-md-5">
                                    <h5 className="fw-bold card-title mb-3"XX</h5>
                                    <p className="fw-bold text-secondary card-text mb-2">XX</p><button className="btn btn-secondary btn-sm" type="button">XX</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
        <section>
            <div className="container py-4 py-xl-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <h2 style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>진행절차</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 col-xl-6 mx-auto p-4">
                        <div className="d-flex align-items-center align-items-md-start align-items-xl-center">
                            <div className="bs-icon-lg bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center me-4 d-inline-block bs-icon xl"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-chat">
                                <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894m-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"></path>
                            </svg></div>
                            <div>
                                <h4 style={{ fontFamily: 'Nanum Gothic', color: 'rgb(249,97,11)', fontWeight: 'bold' }}>Step 01.</h4>
                                <p style={{ fontWeight: 'bold', fontFamily: 'Nanum Gothic', fontSize: '25px' }}>멘토링 요청 등록</p>
                            </div>
                        </div>
                        <hr className="my-5" />
                        <div className="d-flex align-items-center align-items-md-start align-items-xl-center">
                            <div className="bs-icon-lg bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center me-4 d-inline-block bs-icon xl"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-projector">
                                <path d="M14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M2.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"></path>
                                <path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1H5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1 2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"></path>
                            </svg></div>
                            <div>
                                <h4 style={{ fontFamily: 'Nanum Gothic', color: 'rgb(249,97,11)', fontWeight: 'bold' }}>Step 02.</h4>
                                <p style={{ fontWeight: 'bold', fontFamily: 'Nanum Gothic', fontSize: '25px' }}>멘토 후보 검토</p>
                            </div>
                        </div>
                        <hr className="my-5" />
                        <div className="d-flex align-items-center align-items-md-start align-items-xl-center">
                            <div className="bs-icon-lg bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center me-4 d-inline-block bs-icon xl"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-lock">
                                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"></path>
                            </svg></div>
                            <div>
                                <h4 style={{ fontFamily: 'Nanum Gothic', color: 'rgb(249,97,11)', fontWeight: 'bold' }}>Step 03.</h4>
                                <p style={{ fontWeight: 'bold', fontFamily: 'Nanum Gothic', fontSize: '25px' }}>매칭</p>
                            </div>
                        </div>
                        <hr className="my-5" />
                        <div className="d-flex align-items-center align-items-md-start align-items-xl-center">
                            <div className="bs-icon-lg bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center me-4 d-inline-block bs-icon xl"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-file-text">
                                <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"></path>
                                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"></path>
                            </svg></div>
                            <div>
                                <h4 style={{ fontFamily: 'Nanum Gothic', color: 'rgb(249,97,11)', fontWeight: 'bold' }}>Step 04.</h4>
                                <p style={{ fontWeight: 'bold', fontFamily: 'Nanum Gothic', fontSize: '25px' }}>상담 및 조언 진행</p>
                            </div>
                        </div>
                        <hr className="my-5" />
                        <div className="d-flex align-items-center align-items-md-start align-items-xl-center">
                            <div className="bs-icon-lg bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center me-4 d-inline-block bs-icon xl"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-search">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg></div>
                            <div>
                                <h4 style={{ fontFamily: 'Nanum Gothic', color: 'rgb(249,97,11)', fontWeight: 'bold' }}>Step 05.</h4>
                                <p style={{ fontWeight: 'bold', fontFamily: 'Nanum Gothic', fontSize: '25px' }}>피드백 및 매칭 완료</p>
                            </div>
                        </div>
                        <hr className="my-5" />
                    </div>
                </div>
            </div>
        </section>
        {/* <section className="py-5 mt-5">
            <div className="container py-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <p className="fw-bold text-success mb-2">Review</p>
                        <h2 className="fw-bold" style={{fontFamily: 'Nanum Gothic'}}>고객후기</h2>
                        <p className="text-muted" style={{fontFamily: 'Nanum Gothic'}}></p>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 d-sm-flex justify-content-sm-center">
                    <div className="col mb-4">
                        <div className="d-flex flex-column align-items-center align-items-sm-start">
                            <p className="bg-body-tertiary border rounded border-0 border-light p-4"></p>
                            <div className="d-flex">
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div className="col mb-4">
                        <div className="d-flex flex-column align-items-center align-items-sm-start">
                            <p className="bg-body-tertiary border rounded border-0 border-light p-4"></p>
                            <div className="d-flex">
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div className="col mb-4">
                        <div className="d-flex flex-column align-items-center align-items-sm-start">
                            <p className="bg-body-tertiary border rounded border-0 border-light p-4"></p>
                            <div className="d-flex">
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col" style={{textAlign: 'center'}}>
                        <button className="btn btn-primary" type="button" style={{fontFamily: 'Nanum Gothic'}}>후기 더보기</button>
                    </div>
                </div>
            </div>
        </section> */}
        <section className="py-5">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <p className="fw-bold text-success mb-2">Contact</p>
                        <h2 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>멘토링 상담문의</h2>
                    </div>
                </div>

                {/* 멘토/멘티 링크 버튼 섹션 */}
                <div className="row mb-5 d-flex justify-content-center">
                    <div className="col-md-6 col-xl-4 text-center">
                        <p className="mb-3 fw-semibold">멘토로 참여하고 싶다면 아래 버튼을 클릭하세요.</p>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSf0CDM1WeYrc38pAsAW4ap0cZtjozu_zlyYvPAeoIuDJn25jw/viewform" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg w-100 mb-5 shadow">
                            멘토 신청하기(경험 나누기)
                        </a>

                        <p className="mb-3 fw-semibold">멘토를 받고 싶다면 아래 버튼을 클릭하세요.</p>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSfEwHWOPXE8_xZvdQjXcUZHyLmT5D9ChmMTci4xP1m018BhYw/formResponse" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg w-100 shadow">
                            멘티 신청하기(성장 도움받기)
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <script src="assets/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/bold-and-bright.js"></script>
    </>
}
